import { UseFormReturn } from 'react-hook-form';

import { formatWeightForSave } from '../../../shared-utils';
import { FormValues } from '../EditAllocationDialog';

export function useStrategyAllocationManager(form: UseFormReturn<FormValues>) {
    const handleAddStrategy = (strategyGUID: string) => {
        if (!strategyGUID) return;

        const currentAllocations = form.getValues('strategyAllocations');
        const totalWeight = currentAllocations.reduce((sum, strategy) => {
            const weight = parseFloat(strategy.weight || '0');
            return sum + weight;
        }, 0);
        const remainingWeight = Math.max(0, 100 - totalWeight);
        const roundedRemainingWeight = Math.round(remainingWeight * 100) / 100;

        form.setValue('strategyAllocations', [
            ...currentAllocations,
            { strategyGUID: strategyGUID, weight: roundedRemainingWeight.toString() },
        ]);
    };

    const removeStrategy = (strategyGUID: string) => {
        const currentAllocations = form.getValues('strategyAllocations');
        form.setValue(
            'strategyAllocations',
            currentAllocations.filter((s) => s.strategyGUID !== strategyGUID),
        );
    };

    const handleUpdateWeight = (strategyGUID: string, weight: string) => {
        const currentAllocations = form.getValues('strategyAllocations');
        const index = currentAllocations.findIndex((s) => s.strategyGUID === strategyGUID);
        if (index !== -1) {
            currentAllocations[index].weight = weight;
            form.setValue('strategyAllocations', [...currentAllocations]);
        }
    };

    const normalizeDataForSave = (data: FormValues): FormValues => {
        return {
            ...data,
            strategyAllocations: data.strategyAllocations.map((strategy) => ({
                strategyGUID: strategy.strategyGUID,
                weight: formatWeightForSave(strategy.weight),
            })),
        };
    };

    return {
        handleAddStrategy,
        removeStrategy,
        handleUpdateWeight,
        normalizeDataForSave,
    };
}
